import { Transition } from '@headlessui/react';
// import BackgroundImg from '../../assets/images/bg-exio.jpg';
import Logo from '../../assets/images/logo_exio.svg?react';
import { useAppSelector } from '../../hooks';
import { AppStatus, selectAppStatus } from '../../redux';
type AppLoadingProps = {
  show?: boolean;
};

export function AppLoading({ show }: AppLoadingProps) {
  const appStatus = useAppSelector(selectAppStatus);
  return (
    <Transition
      show={show || appStatus === AppStatus.INIT || appStatus === AppStatus.SHUTDOWN}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className="fixed top-0 left-0 right-0 flex flex-col h-full w-full overflow-hidden bg-background dark:bg-gray-900 z-[50] bg-fixed bg-cover bg-no-repeat dark:bg-blend-soft-light"
        // style={{ backgroundImage: `url(${BackgroundImg})`, backgroundPositionY: 4 }}
      >
        <div className="m-auto justify-items-center grid">
          <div>
            <div className="block dark:hidden h-48 w-48">
              <Logo />
            </div>
            {/* <div className="hidden dark:block h-48 w-48">
              <LogoDark />
            </div> */}
          </div>
          <div className="h-[240px]">
            <div className="w-12 h-12 border-2 border-brand-primary rounded-full animate-spin border-r-transparent" />
          </div>
        </div>
      </div>
    </Transition>
  );
}

export default AppLoading;
